import { createAsyncThunk } from '@reduxjs/toolkit';

import config from '@/config';
import {
  UpdateAuthenticationPayload,
  UpdateAuthenticationResponse,
  UpdateAuthenticationTokenInput,
} from '@/features/authentication-update-token/types';
import { GLSAxios } from '@/features/game/gls-axios';
import {
  DdEventCategory,
  DdEventType,
  Logger,
} from '@/features/logging/logger';
import { WrapperProxy } from '@/features/wrapper-proxy/wrapper-proxy';

export const updateAuthenticationToken = createAsyncThunk<
  void,
  UpdateAuthenticationTokenInput
>(
  'authenticationUpdateToken/updateAuthenticationToken',
  async (input, thunkApi) => {
    try {
      Logger.rumAction({
        name: 'Begin update authentication token',
        useCase: DdEventCategory.UpdateAuthentication,
        eventType: DdEventType.Info,
      });
      const axios = GLSAxios(input.fdState.toLocaleLowerCase());
      const gameLaunchUpdateUrl = `${config.fgp.FGPUpdatePath}/authToken`;

      const requestPayload: UpdateAuthenticationPayload = {
        requestId: input.requestId,
        userId: input.userId,
        authToken: input.authToken,
        product: input.product,
      };

      const updateAuthenticationResponse =
        await axios.patch<UpdateAuthenticationResponse>(
          gameLaunchUpdateUrl,
          requestPayload,
        );

      if (updateAuthenticationResponse.data.error) {
        WrapperProxy.setUpdateAuthenticationFailure();
        Logger.rumError({
          name: 'Failed to update authentication token',
          useCase: DdEventCategory.UpdateAuthentication,
          eventType: DdEventType.Error,
          context: {
            data: updateAuthenticationResponse.data.data,
          },
        });
        return thunkApi.rejectWithValue('UPDATE_AUTH_TOKEN_REJECTED');
      }
      Logger.rumAction({
        name: 'Authentication token update success',
        useCase: DdEventCategory.UpdateAuthentication,
        eventType: DdEventType.Success,
      });

      WrapperProxy.setUpdateAuthenticationSuccess();
      return undefined;
    } catch (err) {
      WrapperProxy.setUpdateAuthenticationFailure();
      Logger.rumError({
        name: 'Authentication token update error',
        useCase: DdEventCategory.UpdateAuthentication,
        eventType: DdEventType.Error,
        context: {
          error: err,
        },
      });
      return thunkApi.rejectWithValue('UPDATE_AUTHENTICATION_TOKEN_ERROR');
    }
  },
);
